<template>
<master-layout pageTitle="WhatsApp">
	<div>
    <div v-if="whatsappConnected" class="whatsappContainer">
      <div class="vmb-20 channel-container">
        <div class="cust-brdr optionsContainer flex-between">
          <div class="flex-between">
            <div class="channel-icon-wrap">
              <img src="@/resources/images/whatsapp_icon.svg" width="40" alt="whatsapp_icon" class="iconImg"/>
              <VerificationBadge
                class="channel-verification-badge"
                :verified="isChannelVerified('whatsapp')"
                :error-message="verificationErrorFor('whatsapp')"
              />
            </div>
            <h2 class="vtext-card-title">{{ whatsAppSocialData.name || '-' }}</h2>
          </div>
          <VButton class="vvd-btn-danger-outline" connotation="announcement" appearance="outlined" label="Disconnect" @click="() => disconnectMode = true"></VButton>
        </div>
        <div>
          <div class="flex-start colMargin">
            <p class="vtext-subtitle">Business Number:</p>
            <span class="label-title">{{ whatsAppSocialData.country_code }} {{ whatsAppSocialData.mobile_number }}</span>
          </div>
          <div class="flex-start colMargin">
            <p class="vtext-subtitle">Business ID:</p>
            <span class="label-title">{{ whatsAppSocialData.business_id }}</span>
          </div>
          <div class="flex-start colMargin">
            <p class="vtext-subtitle">App ID:</p>
            <span class="label-title">{{ whatsAppSocialData.appid}}</span>
          </div>
          <div class="colMargin">
            <p class="vtext-subtitle vpb-10">Private key</p>
            <div class="flex-between gap10P">
              <VTextArea v-model="updatedPrivateKey" aria-label="private key" placeholder="Enter Private key" appearance="ghost" class="vivid-textarea"></VTextArea>
              <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Update" :disabled="!updatedPrivateKey" style="height: 40px;" @click="updatePrivateKey"></VButton>
            </div>
          </div>
        </div>
      </div>
      <div class="vrow margin-right">
        <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12">
          <button class="cardContainer" type="button" @click="$router.push('/sales-channel/whatsapp/message-templates')">
            <div class="cardContent">
              <img v-if="isDarkMode" src="../../../resources/images/icebreakers_dark.svg" alt="icebreakers_icon" width="40" class="imgIcons"/>
              <img v-else src="../../../resources/images/message_templates.svg" alt="message_templates_icon" width="40" class="imgIcons"/>
              <div>
                <p class="vtext-card-title vpb-5">Message Templates</p>
                <p class="vtext-subtitle">Create and manage your WhatsApp Business API message templates.</p>
              </div>
            </div>
          </button>
        </div>
        <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12">
          <button class="cardContainer" type="button" @click="$router.push('/sales-channel/whatsapp/widget')">
            <div class="cardContent">
              <img v-if="isDarkMode" src="../../../resources/images/whatsapp_widget_dark.svg" alt="whatsapp_widget_dark" width="40" class="imgIcons"/>
              <img v-else src="../../../resources/images/whatsapwidget.svg" alt="whatsapp_widget" width="40" class="imgIcons"/>
              <div>
                <p class="vtext-card-title vpb-5">WhatsApp Widget</p>
                <p class="vtext-subtitle">Add the WhatsApp chat widget on your website.</p>
              </div>
            </div>
          </button>
        </div>
        <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12">
          <button class="cardContainer vmt-10" type="button" @click="$router.push('/sales-channel/whatsapp/compliance-keywords')">
            <div class="cardContent">
              <img v-if="isDarkMode" src="../../../resources/images/compliance-keywords_dark.svg" alt="compliance_keywords_dark" width="40" class="imgIcons"/>
              <img v-else src="../../../resources/images/compliance-keywords.svg" alt="compliance_keywords" width="40" class="imgIcons"/>
              <div>
                <p class="vtext-card-title vpb-5">Compliance keywords</p>
                <p class="vtext-subtitle">Set keywords that let users opt in or out receiving notifications.</p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div v-else class="connect-channel-container">
      <div class="cust_brdr sectionPadding">
        <p class="vtext-page-title">Connect WhatsApp</p>
      </div>
      <!-- Step 1: Connection Method Selection -->
      <div v-if="currentStep === 'selection'" class="step-container">
        <div class="step-content">
          <div class="flex-center selection-container">
            <div>
              <h1 class="vtext-card-title text-center vpb-10">Select a connection method</h1>
              <p class="vtext-subtitle text-center">Select the option that best suits you.</p>
            </div>
          </div>
          <div class="sectionPadding">
            <div class="radio-card-group">
              <!-- Auto Option -->
              <div :class="['radio-card', { selected: selectedConnectionMethod === 'auto' }]" @click="selectedConnectionMethod = 'auto'">
                <div class="radio-card-content">
                  <div>
                    <h3>Guided Setup</h3>
                    <p>Create and connect your Vonage application directly through Jumper using a simplified, step-by-step form. No need to switch to the Vonage API Dashboard to create the application.</p>
                  </div>
                  <VIcon :name="selectedConnectionMethod === 'auto' ? 'radio-checked-line' : 'radio-unchecked-line'" :connotation="selectedConnectionMethod === 'auto' ? 'cta' : undefined" class="radio-icon"></VIcon>
                </div>
              </div>
              <!-- Manual Option -->
              <div :class="['radio-card', { selected: selectedConnectionMethod === 'manual' }]" @click="selectedConnectionMethod = 'manual'">
                <div class="radio-card-content">
                  <div>
                    <h3>Manual Setup</h3>
                    <p>Use the <a href="https://dashboard.nexmo.com/applications" target="_blank" rel="noopener noreferrer" class="dashboard-link" @click.stop>Vonage API Dashboard</a> to create an application, then manually fill out the required details in the Jumper form to complete the connection.</p>
                  </div>
                  <VIcon :name="selectedConnectionMethod === 'manual' ? 'radio-checked-line' : 'radio-unchecked-line'" :connotation="selectedConnectionMethod === 'manual' ? 'cta' : undefined" class="radio-icon"></VIcon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sectionPadding navigation-section">
          <div class="navigation-buttons flex-between">
            <VButton class="vvd-btn-primary flex100P" connotation="cta" appearance="filled" label="Next" @click="nextStep"></VButton>
          </div>
        </div>
      </div>

      <!-- Step 2: Auto Connection -->
      <div v-else-if="currentStep === 'auto'" class="step-container">
        <div class="step-content">
          <ConnectChannel 
            :channel-type="'whatsapp'"
            @go-back="handleGoBack"
          />
        </div>
      </div>

      <!-- Step 3: Manual Connection -->
      <div v-else-if="currentStep === 'manual'" class="step-container">
        <div class="step-content">
          <div class="gridMargin">
            <div class="vrow vmb-20">
              <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin custPaddingRight">
                <p class="vtext-subtitle vpb-10">API key <span class="important">*</span></p>
                <VTextField v-model="account.apikey" placeholder="Enter API key" aria-label="API key" appearance="ghost" class="vivid-input"></VTextField>
              </div>
              <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin">
                <p class="vtext-subtitle vpb-10">API secret <span class="important">*</span></p>
                <VTextField v-model="account.apisecret" placeholder="Enter API secret" aria-label="API secret" appearance="ghost" class="vivid-input"></VTextField>
              </div>
            </div>
            <div class="vrow vmb-20">
              <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin custPaddingRight">
                <p class="vtext-subtitle vpb-10">App ID<span class="important">*</span></p>
                <VTextField v-model="account.appId" placeholder="Enter App ID" aria-label="API ID" appearance="ghost" class="vivid-input"></VTextField>
              </div>
              <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin">
                <p class="vtext-subtitle vpb-10">App name<span class="important">*</span></p>
                <VTextField v-model="account.appName" placeholder="Enter App name" aria-label="API name" appearance="ghost" class="vivid-input"></VTextField>
              </div>
            </div>
            <div class="vrow vmb-20">
              <div class="vcol vcol--no-padding vcol-12 colMargin">
                <p class="vtext-subtitle vpb-10">Private key <span class="important">*</span></p>
                <VTextArea v-model="account.privateKey" aria-label="private key" placeholder="Enter Private key" appearance="ghost" class="vivid-textarea"></VTextArea>
              </div>
            </div>
            <div class="vrow vmb-20">
              <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin custPaddingRight">
                <p class="vtext-subtitle vpb-10">Phone No.<span class="important">*</span></p>
                <mobile-input v-model:countryCode="account.countryCode" v-model:mobile="account.mobileNumber" placeholder="Enter Mobile Number"></mobile-input>
              </div>
              <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin">
                <p class="vtext-subtitle vpb-10">WABA ID <span class="important">*</span></p>
                <VTextField v-model="account.wabaID" placeholder="Enter WABA ID" aria-label="WABA ID" appearance="ghost" class="vivid-input"></VTextField>
              </div>
            </div>
          </div>
        </div>
        <div class="sectionPadding navigation-section">
          <div class="navigation-buttons flex-between">
            <VButton class="vvd-btn-cancel flex100P" appearance="filled" label="Previous" @click="previousStep"></VButton>
            <VButton class="vvd-btn-primary flex100P" connotation="cta" appearance="filled" :label="spinnerLoading ? 'Submitting...' : 'Submit'" :disabled="isDisabled || spinnerLoading" @click="createWhatsappAccount"></VButton>
          </div>
        </div>
      </div>
    </div>		
	</div>
   <!-- Disconnect Confirmation Dialog -->
   <VDialog :open="disconnectMode" modal @close="disconnectMode = false">
    <template #body>
      <div class="exportImgContainer vmb-20">
        <VIcon name="delete-line" :size="-5" class="customer_delete"></VIcon>
        <p class="vtext-modal-title text-center">Are you sure ?</p>
        <p class="vtext-subtitle text-center">Disconnecting this WhatsApp channel may remove access to past conversations. Message templates tied to this WABA cannot be reused with another WABA, which may impact scheduled or completed broadcasts, including viewing or duplicating them.</p>
      </div>
    </template>
    <template #action-items>
      <div class="footerBttn">
        <VButton class="vvd-btn-cancel flex100P" appearance="filled" label="Cancel" @click="() => disconnectMode = false"></VButton>
        <VButton class="vvd-btn-primary flex100P" connotation="cta" appearance="filled" label="Confirm" @click="confirmDisconnect('whatsapp')"></VButton>
      </div>
    </template>
   </VDialog>

   <!-- Reconnect Confirmation Dialog -->
   <VDialog :open="showReconnectDialog" headline="Reconnect Account" modal @close="showReconnectDialog = false">
    <template #body>
      <p class="vtext-body">This appears to be previously disconnected account, connecting this will show the data associated with that connection. Do you want to proceed?</p>
    </template>
    <template #action-items>
      <VButton class="vvd-btn-cancel" appearance="filled" label="No" @click="handleReconnectNo"></VButton>
      <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="reconnectWhatsApp"></VButton>
    </template>
   </VDialog>
</master-layout>
</template>

<script>
import apiInterceptor from '@/shared/apiInterceptor';
import MobileInput from '@/components/mobileInput.vue';
import ConnectChannel from '@/pages/sales-channel/connect-channel.vue';
import VerificationBadge from '@/components/VerificationBadge.vue';
import { useUIStore } from '@/stores/ui';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { useConnectionVerification } from '@/composables/useConnectionVerification';
import { environment } from '@/shared/env';
import { useAuthStore } from '@/stores/auth';

export default {
  components: {MobileInput, ConnectChannel, VerificationBadge},
  setup() {
    const { whatsappConnected, whatsAppSocialData } = useSocialChannels();
    // Verify only this channel via ?channels=whatsapp
    const { isChannelVerified, verificationErrorFor, refreshChannel, invalidateChannel } = useConnectionVerification(['whatsapp']);
    return { whatsappConnected, whatsAppSocialData, isChannelVerified, verificationErrorFor, refreshChannel, invalidateChannel };
  },
  data() {
    return {
      account: {
        apikey: '',
				apisecret: '',
				appId: '',
				appName: '',
				wabaID: '',
				mobileNumber: '',
        privateKey: '',
      },
      countryCode: '',
      spinnerLoading: false,
      disabled: true,
      disconnectMode: false,
      showReconnectDialog: false,
      updatedPrivateKey: '',
      selectedConnectionMethod: 'auto',
      currentStep: 'selection' 
    }
  },
  computed:{
    isDarkMode() { return useUIStore().isDarkMode; },
    isDisabled(){
      return !this.account.apikey || !this.account.apisecret || !this.account.appId || !this.account.appName || !this.account.privateKey || !this.account.wabaID || !this.account.mobileNumber;
    }
  },
  methods: {
    async createWhatsappAccount() {
      try {
				this.spinnerLoading = true;
        if(this.isDisabled){
          return
        }
				let reqBody = {
          mobilenumber: this.account.mobileNumber,
          countrycode: this.account.countryCode,
          business_id: this.account.wabaID,
          apikey: this.account.apikey,
          apisecret: this.account.apisecret,
          appid: this.account.appId,
          appname: this.account.appName,
          privatekey: this.account.privateKey,
          active: false,
          addextra: false,
          confirm: false
				}
        const response = await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/whatsapp-vonage", reqBody );
        
        if(response.data === null && response.dialogMessage){
          this.spinnerLoading = false;
          await this.showReconnectConfirmationWhatsApp();
          return;
        }
        
        useUIStore().updateToast({
          open: true,
          message: "Your WhatsApp registration is done successfully!",
          type: "success"
        })
        
        // Dispatch custom event to refresh LiveChatHome customers
        const refreshEvent = new CustomEvent("refresh-customers", {
          detail: { 
            action: "connect",
            channel: "whatsapp",
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);
        
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('whatsapp');
			} catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" });
			} finally {
				this.spinnerLoading = false;
			}
    },
    async confirmDisconnect() {
      try {
        // Close the confirm dialog first so it doesn't sit in front of the loader.
        this.disconnectMode = false;
        useUIStore().updateLoading({ isLoading: true, message: 'Disconnecting...' });
        await apiInterceptor.delete(environment("VUE_APP_API_URL") + "social/v1/whatsapp");
        useUIStore().updateToast({ open: true, message: "Done!,Your Whatsapp account has been disconnected successfully.", type: "success" })
        // Disconnected channels are never verified — clear the status locally.
        this.invalidateChannel('whatsapp');
        this.resetData();
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        
        // Dispatch custom event to refresh LiveChatHome customers
        const refreshEvent = new CustomEvent("refresh-customers", {
          detail: { 
            action: "disconnect",
            channel: "whatsapp",
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    resetData() {
      this.account = {
        agentname: '',
        apisecret: '',
        appid: '',
        appname: '',
        apikey: '',
        privatekey: '',
      }
    },
    async updatePrivateKey() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Updating private key...' });
        if (!this.updatedPrivateKey) {
          return useUIStore().updateToast({
            open: true,
            message: "Private key cannot be empty",
            type: "danger"
          })
        }
        let reqBody = {
          privatekey: this.updatedPrivateKey,
				}
        await apiInterceptor.patch(environment("VUE_APP_API_URL") + `social/v1/whatsapp-vonage/${this.whatsAppSocialData.id}`, reqBody );
        useUIStore().updateToast({
          open: true,
          message: "Private key updated successfully!",
          type: "success"
        });
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('whatsapp');
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || "Failed to update private key",
          type: "danger"
        });
      } finally {
        this.updatedPrivateKey = '';
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    nextStep() {
      if (this.selectedConnectionMethod === 'auto') {
        this.currentStep = 'auto';
      } else if (this.selectedConnectionMethod === 'manual') {
        this.currentStep = 'manual';
      }
    },
    previousStep() {
      // Go back to selection step
      this.currentStep = 'selection';
      
      // Clear all manual form data
      this.resetData();
    },
    handleGoBack() {
      // Handle go back from ConnectChannel component
      this.currentStep = 'selection';
      // Clear all form data
      this.resetData();
    },
    async showReconnectConfirmationWhatsApp() {
      this.showReconnectDialog = true;
    },
    handleReconnectNo() {
      this.showReconnectDialog = false;
      this.previousStep();
    },
    async reconnectWhatsApp() {
      try {
        this.showReconnectDialog = false;
        this.spinnerLoading = true;
        let reqBody = {
          mobilenumber: this.account.mobileNumber,
          countrycode: this.account.countryCode,
          business_id: this.account.wabaID,
          apikey: this.account.apikey,
          apisecret: this.account.apisecret,
          appid: this.account.appId,
          appname: this.account.appName,
          privatekey: this.account.privateKey,
          active: false,
          addextra: false,
          confirm: true
        }
        await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/whatsapp-vonage", reqBody );
        
        useUIStore().updateToast({
          open: true,
          message: "Your WhatsApp registration is done successfully!",
          type: "success"
        })
        
        // Dispatch custom event to refresh LiveChatHome customers
        const refreshEvent = new CustomEvent("refresh-customers", {
          detail: { 
            action: "connect",
            channel: "whatsapp",
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);
        
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('whatsapp');
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Failed to reconnect account", type: "danger" });
      } finally {
        this.spinnerLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: var(--black);
}
.padding-bottom {
  padding-bottom: 5px;
}
.cardContainer {
  min-height: 90px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: var(--white);
  border: 1px solid var(--white);
  box-shadow: none;
  margin: 0px 10px;
  width: calc(100% - 20px);
  padding: 15px 20px;
  text-align: left;
  font: inherit;
  outline: none;
}
.cardContainer:hover {
  border-color: var(--purple);
}
.cardContainer:focus-visible {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}
.cardContent {
  display: flex;
  align-items: center;
  width: 100%;
}

.vivid-textarea {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}

.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}

.imgIcons{
  margin-right: 20px;
  flex-shrink: 0;
}
.model-sections {
  background: var(--white);
  border-radius: 5px;
}
.sectionPadding{
  padding: 15px 20px;
}
.custPaddingRight{
  padding-right: 20px;
}
.previewHeader{
  border-bottom: 1px solid var(--background-primary);
  color: var(--black);
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  padding: 20px;
}
.colMargin {
  margin-bottom: 10px;
}
.whatsappContainer{
  margin: 20px 10px;
}
.channel-container {
  background: var(--white);
  border-radius: 5px;
  padding: 20px;
  margin: 10px;
}
.iconImg{
  width: 40px;
  height: 40px;
}
.channel-icon-wrap {
  position: relative;
  display: inline-block;
  line-height: 0;
}
.channel-verification-badge {
  position: absolute;
  top: -6px;
  right: -6px;
}
.label-title{
  font-size: 14px;
  font-weight: 700;
  color: var(--black);
}
.exportImgContainer{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
}
.footerBttn{
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 10px;
}
.customer_delete{
  background: var(--orange);
  border-radius: 5px;
  padding: 5px;
}
.connect-channel-container {
  max-width: 950px;
  border-radius: 5px;
  margin: 20px auto 30px auto;
  min-height: calc(100dvh - 120px);
  height: calc(100% - 30px);
  background: var(--white);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.step-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
}

.step-content {
  flex: 1;
}

.navigation-section {
  margin-top: auto;
}

.channel-title {
  font-size: 18px;
  font-weight: 400;
  line-height: 16px;
  color: var(--black);
}
.channel-description {
  font-size: 14px;
  color: var(--gray-04);
  margin: 0;
}
.radio-card-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1rem;
}

.radio-card {
  flex: 1 1 300px;
  border: 1px solid var(--background-primary);
  border-radius: 12px;
  padding: 1rem;
  transition: border-color 0.3s ease;
  background: var(--white);
  cursor: pointer;
}

.radio-card.selected {
  border-color: var(--purple);
}

.radio-card h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--black);
}

.radio-card p {
  font-size: 14px;
  font-weight: 400;
  color: var(--gray-04);
  margin: 0.5rem 0 0;
}
.selection-container{
  padding: 20px 0px;
  border-bottom: 1px solid var(--background-primary);
}
.manual-buttons {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-top: 24px;
}
.dashboard-link {
  color: var(--purple);
  text-decoration: underline;
  font-weight: 400;
}
.dashboard-link:hover {
  color: var(--purple);
  opacity: 0.8;
}
.margin-right{
  margin: 0px;
}
.radio-card-content{
  display: flex;
  align-items: center;
  gap: 25px;
}
.gridMargin {
  margin: 25px 30px;
}
@media only screen and (max-width: 760px) {
  .custPaddingRight{
    padding-right: 0px;
  }
  .whatsapp-connection{
    margin: 20px;
    max-width: 100%;
  }
  .cardContainer {
    margin: 10px;
  }
}

</style>
